// Sections.js (main component)
import React, { useState } from 'react'
import { withStyles } from '@material-ui/core'
import {
  StandAloneCover,
  SortableSection,
  AddSectionButton,
  useSectionDragAndDrop,
  SectionsContainer,
  SectionsDrawer,
} from './components'

import styles from './styles'
import { useSelector } from 'react-redux'
import PublishSummary from '../publish-summary'

const Sections = props => {
  const { classes, sections, setSections } = props
  const open = useSelector(state => state.course.sectionDrawerOpen)
  const course = useSelector(state => state.course.course)
  const {
    activeId,
    handleDragStart,
    handleDragOver,
    handleDragEnd,
  } = useSectionDragAndDrop(sections, setSections, course?.id)

  return (
    <SectionsDrawer open={open} classes={classes}>
      <StandAloneCover />
      <PublishSummary />
      <SectionsContainer
        classes={classes}
        open={open}
        sections={sections}
        handleDragStart={handleDragStart}
        handleDragOver={handleDragOver}
        handleDragEnd={handleDragEnd}
        activeId={activeId}
      >
        {sections.map(section => (
          <SortableSection
            key={`section__${section.id}`}
            section={section}
            setSections={setSections}
            sections={sections}
            activeId={activeId}
          />
        ))}
        <AddSectionButton sections={sections} setSections={setSections} />
      </SectionsContainer>
    </SectionsDrawer>
  )
}

export default withStyles(styles)(Sections)
